export default __webpack_public_path__ + "static/cloud-da30f45b8a54e0966892c1d2bb58a121.jpg";